<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">下单时间{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" class="width-250" v-model="search.bat_code">
                        <span slot="prepend">批次号{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5" v-if="mod_cat == 'M1'">
                    <el-input size="small" class="width-250" v-model="search.org_cname">
                        <span slot="prepend">客户名称{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" class="width-250" v-model="search.vendor_cname">
                        <span slot="prepend">供应商名称{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" class="width-250" v-model="search.goods_cname">
                        <span slot="prepend">商品名称{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="listHeader.goods_cname" width="160px">
                        <el-table-column label-class-name="f-red pd-top0" width="160px">
                            <div class="f-red" slot-scope="scope" slot="header">合计</div>
                            <div class="f-brown" slot-scope="scope">{{scope.row.goods_cname}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" min-width="170px"></el-table-column>
                    <el-table-column :label="listHeader.goods_amt" width="90px">
                        <div slot-scope="scope">{{scope.row.goods_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column v-if="mod_cat == 'M1'" prop="org_cname" :label="listHeader.org_cname" min-width="150px"></el-table-column>
                    <el-table-column :label="listHeader.guest_cost_amt" width="110px">
                        <div slot-scope="scope">{{scope.row.guest_cost_amt * 1}}</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.order_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.order_qty * 1}}</div>
                            <div slot-scope="scope">{{scope.row.order_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.over_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.over_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.over_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-green" slot-scope="scope" slot="header">{{totalData.sum.ok_qty * 1}}</div>
                            <div class="f-bd f-green" slot-scope="scope">{{scope.row.ok_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="100px">
                            <div class="f-green" slot-scope="scope" slot="header">{{totalData.sum.ok_goods_amt * 1}}</div>
                            <div class="f-bd f-green" slot-scope="scope">{{scope.row.ok_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.ok_guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="130px">
                            <div class="f-green" slot-scope="scope" slot="header">{{totalData.sum.ok_guest_cost_amt * 1}}</div>
                            <div class="f-bd f-green" slot-scope="scope">{{scope.row.ok_guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="vendor_cname" :label="listHeader.vendor_cname" min-width="150px"></el-table-column>
                    <el-table-column :label="listHeader.ok_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="130px">
                            <div class="f-blue" slot-scope="scope" slot="header">{{totalData.sum.ok_cost_amt * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.ok_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.tot_goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div class="f-black" slot-scope="scope" slot="header">{{totalData.sum.tot_goods_amt * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.tot_goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.tot_guest_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div class="f-black" slot-scope="scope" slot="header">{{totalData.sum.tot_guest_cost_amt * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.tot_guest_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.tot_cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div class="f-black" slot-scope="scope" slot="header">{{totalData.sum.tot_cost_amt * 1}}</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.tot_cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.err_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="90px">
                            <div class="f-red" slot-scope="scope" slot="header">{{totalData.sum.err_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.err_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="bat_code" :label="listHeader.bat_code" min-width="160px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import excel from '../../../utils/excel'
export default {
    name:'order-cbat',
    components:{
        myPager,
        myDatePicker
    },
    data: function(){
        const listHeader = {
            goods_cname: '商品',
            add_time: '下单时间',
            goods_amt: '面值',
            org_cname: '客户',
            guest_cost_amt: '客户结算单价',
            order_qty: '单量',
            over_qty: '完成单量',
            ok_qty: '成功单量',
            ok_goods_amt: '成功面值',
            ok_guest_cost_amt: '客户成功结算价',
            vendor_cname: '供应商',
            ok_cost_amt: '供应商成功结算价',
            tot_goods_amt: '总面值',
            tot_cost_amt: '供应商总结算价',
            tot_guest_cost_amt: '客户总结算价',
            err_qty: '失败单量',
            bat_code: '批次号'
        }
        return{
            relist: false,
            show_subview: false,
            mod_cat: this.$base.getModCat(),
            excel_frow_num: 2, //固定两行
            excel_fcol_num: 1, //固定三列
            search:{
                search_url: 'order-c-bat/list',
                datearea_id:1,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'20',
                bat_code: "",
                vendor_cname:'',
                goods_cname:'',
                org_cname:''
            },
            listHeader,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            }
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/order/cbat/list.vue